var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"ProductAvailability",class:[_vm.isAvailable ? 'ProductAvailability--available' : 'ProductAvailability--notAvailable'],domProps:{"innerHTML":_vm._s(_vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }